var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"placeholder":"请选择合同状态","clearable":""},on:{"change":_vm.change}},_vm._l(([{
				value:'UNSIGNED',
				label:'无合同'
			},
			{
				value:'NORMAL',
				label:'正常'
			},
			{
				value:'CANCELLED',
				label:'解除'
			},
			{
				value:'EXPIRED',
				label:'到期'
			},
				{
				value:'AAA',
				label:'AAA'
			}]),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }